import { createContext, useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ShipToCreationData } from './shipToCreationData';
import { ShipToCreationForm } from './shipToCreationForm.types';

export type ShipToCreationContextValue = {
  shipToCreationForm: UseFormReturn<ShipToCreationForm>;
  processData: ShipToCreationData;
};

export const ShipToCreationContext = createContext<ShipToCreationContextValue | undefined>(undefined);

export const useShipToCreationContext = (): ShipToCreationContextValue => {
  const context = useContext(ShipToCreationContext);

  if (context === undefined) {
    throw new Error('useShipToCreationContext must be used within a ShipToCreationProvider');
  }

  return context;
};
